import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { TabLinks, TabButton, TabLink } from "./TabsStyles";

const Tabs = ({
  tabs,
  contentHeader = null,
  enableLocation = true,
  justifyLinks = false,
  onTabChange = () => {},
}) => {
  const [active, setActive] = useState(0);
  const [tabList, setTabList] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const newTabs = tabs.map((t) => {
      return { ...t, key: t.label.replace(/\s+/g, "-").toLowerCase() };
    });

    setTabList(newTabs);

    if (!location.hash || location.hash === "") {
      setActive(newTabs[0].key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs]);

  useEffect(() => {
    if (location.hash && location.hash !== "" && enableLocation) {
      setActive(location.hash.replace(/^#/, ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, enableLocation]);

  useEffect(() => {
    onTabChange(active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  return (
    <div>
      <TabLinks justifylinks={justifyLinks ? "true" : ""}>
        {tabList.map((tab, tabIndex) => {
          if (!enableLocation) {
            return (
              <TabButton
                key={tabIndex}
                variant="link"
                className={tab.key === active}
                onClick={() => {
                  setActive(tab.key);
                  if (tab.onClick) {
                    tab.onClick(tab.key);
                  }
                }}
                justifylinks={justifyLinks ? "true" : ""}
              >
                {tab.label}
              </TabButton>
            );
          }

          return (
            <TabLink
              key={tabIndex}
              to={`#${tab.key}`}
              className={tab.key === active ? "active" : ""}
              justifylinks={justifyLinks ? "true" : ""}
            >
              {tab.label}
            </TabLink>
          );
        })}
      </TabLinks>
      {contentHeader}
      {tabList.map((tab, tabIndex) => {
        if (tab.key !== active) {
          return null;
        }
        return (
          <div key={tabIndex} className="tab-content">
            {tab.content}
          </div>
        );
      })}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  contentHeader: PropTypes.node,
  enableLocation: PropTypes.bool,
  justifyLinks: PropTypes.bool,
};

export default Tabs;
